// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(field) {
  return function (className) {
    return function (children) {
      const text = field.valueForDisplay;
      let tmp;
      tmp = text.TAG === /* Ok */0 ? null : JsxRuntime.jsx("p", {
              children: text._0,
              className: "mt-1 text-red-500 text-sm"
            });
      return JsxRuntime.jsxs("div", {
                  children: [
                    children,
                    tmp
                  ],
                  className: Cn.fromList({
                        hd: Cn.take(className),
                        tl: /* [] */0
                      })
                });
    };
  };
}

function FieldValidationErrorWrapper(Props) {
  return Curry._1(make(Props.field)(Props.className), Props.children);
}

const make$1 = FieldValidationErrorWrapper;

export {
  make$1 as make,
}
/* react/jsx-runtime Not a pure module */
